/**
 * @author gyb(mocheer)
 * @email `mocheer@foxmail.com`  
 * @since 2019-1-17
 */
let KAPPA = (4 * (Math.sqrt(2) - 1)) / 3;
let WIDTH_FACTOR = 0.0333;
let HEIGHT_FACTOR = 0.4;
/**
 * 
 */
L.Canvas.include({
  /**
   * 
   */
  _updateBalloon(layer) {
    if (!this._drawing || layer._empty()) {
      return;
    }
    //
    var p = layer._point;
    let ctx = this._ctx;
    var options = layer.options;
    //
    let {
      x,
      y
    } = p;

    let {
      radius,
      color,
      offset,
      label
    } = options;
    radius -= 3;
    //
    if (!offset) {
      offset = [0, -32]
    }
    x += offset[0];
    y += offset[1];

    var handleLength = KAPPA * radius * .6;

    var widthDiff = (radius * WIDTH_FACTOR);
    var heightDiff = (radius * HEIGHT_FACTOR);

    var balloonBottomY = y + radius + heightDiff;

    // 开始绘制
    ctx.beginPath();

    // Top Left Curve
    var topLeftCurveStartX = x - radius;
    var topLeftCurveStartY = y;

    var topLeftCurveEndX = x;
    var topLeftCurveEndY = y - radius;

    ctx.moveTo(topLeftCurveStartX, topLeftCurveStartY);
    ctx.bezierCurveTo(topLeftCurveStartX, topLeftCurveStartY - handleLength - widthDiff,
      topLeftCurveEndX - handleLength, topLeftCurveEndY,
      topLeftCurveEndX, topLeftCurveEndY);

    // Top Right Curve
    var topRightCurveStartX = x;
    var topRightCurveStartY = y - radius;

    var topRightCurveEndX = x + radius;
    var topRightCurveEndY = y;

    ctx.bezierCurveTo(topRightCurveStartX + handleLength + widthDiff, topRightCurveStartY,
      topRightCurveEndX, topRightCurveEndY - handleLength,
      topRightCurveEndX, topRightCurveEndY);

    // Bottom Right Curve
    var bottomRightCurveStartX = x + radius;
    var bottomRightCurveStartY = y;

    var bottomRightCurveEndX = x;
    var bottomRightCurveEndY = balloonBottomY;

    ctx.bezierCurveTo(bottomRightCurveStartX, bottomRightCurveStartY + handleLength,
      bottomRightCurveEndX + handleLength, bottomRightCurveEndY,
      bottomRightCurveEndX, bottomRightCurveEndY);

    // Bottom Left Curve
    var bottomLeftCurveStartX = x;
    var bottomLeftCurveStartY = balloonBottomY;

    var bottomLeftCurveEndX = x - radius;
    var bottomLeftCurveEndY = y;

    ctx.bezierCurveTo(bottomLeftCurveStartX - handleLength, bottomLeftCurveStartY,
      bottomLeftCurveEndX, bottomLeftCurveEndY + handleLength,
      bottomLeftCurveEndX, bottomLeftCurveEndY);

    ctx.fillStyle = color;
    ctx.fill();

    //
    ctx.beginPath();
    ctx.strokeStyle = color;
    ctx.moveTo(x, balloonBottomY);
    ctx.lineTo(x, balloonBottomY + 3);
    ctx.stroke();
    //
    if (label) {
      ctx.beginPath();
      ctx.font = '14px arial';
      ctx.fillStyle = 'white';
      ctx.textAlign = 'center';
      ctx.fillText(label, x, y + 5);
    }
  }
});



// WEBPACK FOOTER //
// ./src/feature/Balloon.js